import PropTypes from 'prop-types';
import React from 'react';

import { useMobileMediaQuery } from '@/hooks/useMobileMediaQuery';

import { Wrapper } from './OnlyDesktop.style';

/**
 * Present content only in desktop (above MUI 'md' breakpoint).
 */
const OnlyDesktop = ({ children, unmountOnHide }) => {
  const mobileMediaQuery = useMobileMediaQuery();

  if (unmountOnHide) {
    return !mobileMediaQuery ? children : null;
  }

  return <Wrapper>{children}</Wrapper>;
};

OnlyDesktop.propTypes = {
  /** Content to be presented. */
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.element,
  ]).isRequired,
  unmountOnHide: PropTypes.bool,
};

export default OnlyDesktop;
